/* src/app/cardholders/history/history.component.css */
/*# sourceMappingURL=history.component.css.map */
